import React from 'react'

import { Checkbox } from 'slab'

import StateDisplay from './StateDisplay'

interface StateSelectionSectionProps {
  title: string
  description: string
  type: 'projected' | 'delivered'
  selectedStates: string[]
  setSelectedStates: (states: string[]) => void
  availableStates: string[]
}

export default function StateSelectionSection ({
  title,
  description,
  type,
  selectedStates,
  setSelectedStates,
  availableStates
}: StateSelectionSectionProps) {
  const primaryButtonClass = type === 'projected'
    ? 'bg-blue-600 hover:bg-blue-700'
    : 'bg-green-600 hover:bg-green-700'

  return (
    <div className='space-y-4' data-testid={`state-selection-${type}`}>
      <div className='space-y-2'>
        <label className='block text-base font-medium text-gray-700'>{title}</label>
        <p className='text-sm text-gray-500'>{description}</p>
      </div>

      <StateDisplay
        states={selectedStates}
        type={type}
        label='Selected States'
        data-testid={`state-display-${type}`}
      />

      <div className='space-y-3'>
        <div className='flex items-center gap-2'>
          <button
            type='button'
            onClick={() => setSelectedStates(availableStates)}
            className={`text-xs text-white px-2 py-1 rounded font-medium ${primaryButtonClass}`}
            data-testid={`select-all-${type}`}
          >
            Select All Available ({availableStates.length})
          </button>
          <button
            type='button'
            onClick={() => setSelectedStates([])}
            className='text-xs bg-gray-500 text-white px-2 py-1 rounded hover:bg-gray-600 font-medium'
            data-testid={`clear-all-${type}`}
          >
            Clear All
          </button>
        </div>

        <div className='border rounded-md p-3 max-h-48 overflow-y-auto'>
          <div className='grid grid-cols-5 gap-x-4 gap-y-2'>
            {availableStates.map(state => (
              <div key={state} className='flex items-center space-x-2'>
                <Checkbox
                  id={`${type}-${state}`}
                  checked={selectedStates.includes(state)}
                  onChange={(e) => {
                    const checked = e.target.checked
                    if (checked) {
                      setSelectedStates([...selectedStates, state])
                    } else {
                      setSelectedStates(selectedStates.filter(s => s !== state))
                    }
                  }}
                />
                <label htmlFor={`${type}-${state}`} className='text-sm font-medium cursor-pointer'>
                  {state}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
